import React from "react";
import { getCurrentEnvironment } from "Utils/environment";

/**
 * EnvironmentWrapper
 *
 * Usage:
 * <EnvironmentWrapper env={["dev", "qa"]}>
 *    <YourComponent />
 * </EnvironmentWrapper>
 */
const EnvironmentWrapper = ({ env, children }) => {
  const currentEnv = getCurrentEnvironment();

  if (!env?.includes(currentEnv)) {
    return null;
  }

  return <>{children}</>;
};

export default EnvironmentWrapper;
